import MultiLine from '../multi-line/MultiLine';

interface AssignmentCommonOverviewProps {
  overview: string;
}

const AssignmentCommonOverview = (props: AssignmentCommonOverviewProps) => <div>{props.overview && <MultiLine text={props.overview} />}</div>;

AssignmentCommonOverview.displayName = 'AssignmentCommonOverview';
export default AssignmentCommonOverview;
